import { useQueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/client';
import { useToast } from '@/components/kit/Toast';

export const errorText = (e: unknown, fallback = 'Не сохранилось') =>
  e instanceof ApiError || e instanceof Error ? e.message : fallback;

/**
 * Действие в строке связи (ТЗ M2 §8): выполняется сразу, тост с
 * «Отменить» живёт 7 секунд. «Отменить» вызывает обратную операцию на
 * сервере — ей передаются записи ленты прямого действия, чтобы лента
 * выглядела так, будто его не было. Локальное состояние не откатывается:
 * всё перечитывается с сервера.
 */
export function useUndoable() {
  const client = useQueryClient();
  const toast = useToast();
  const refresh = () => client.invalidateQueries({ queryKey: ['base'] });

  return async function run<R extends { feedEntryIds?: string[] }>(
    action: () => Promise<R>,
    message: string,
    undo?: (result: R) => Promise<unknown>,
  ): Promise<void> {
    try {
      const result = await action();
      await refresh();
      toast.show(message, {
        onUndo: undo
          ? () => {
              undo(result)
                .then(refresh)
                .catch((e) => toast.showError(errorText(e, 'Не удалось отменить')));
            }
          : undefined,
      });
    } catch (e) {
      toast.showError(errorText(e));
    }
  };
}
